import React from "react";

// App-shell chrome state shared between Sidebar.js (owns the nav) and
// NavigationBar.js (owns the topbar's collapse/hamburger buttons), which sit
// in different parts of the tree - see App.js.
const LayoutContext = React.createContext(null);
export { LayoutContext };
